import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { InternalUserFoSave } from 'core/application/csiDashboard/internalUsers/getInternalUserForSave'
import { SaveInternalUserRequest } from 'core/application/csiDashboard/internalUsers/saveInternalUser'

import Tooltip from 'common/components/dataDisplay/Tooltip'
import Checkbox from 'common/components/dataEntry/components/Checkbox'
import FormikCheckboxGroupField from 'common/components/dataEntry/formik/FormikCheckboxGroupField'
import Input from 'common/components/dataEntry/formik/FormikDefaultInputField'
import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'

const InternalUsersForm: React.FC<InternalUsersFormProps> = ({
  initialValues,
  visible,
  onCancel,
  onSubmit,
  submitting,
}) => {
  let { t: translate } = useTranslation()
  const [formIsValid, setFormIsValid] = useState<boolean>(false)
  const [saveInternalUserRequest, setSaveInternalUserRequest] = useState<SaveInternalUserRequest>(
    {} as SaveInternalUserRequest,
  )

  const SaveButtonWithTooltip = () => {
    return !formIsValid ? (
      <Tooltip title="Complete all the fields to continue" position="right">
        {``}
        <SaveButton />
      </Tooltip>
    ) : (
      <SaveButton />
    )
  }

  const SaveButton = () => {
    return (
      <Button
        loading={submitting}
        onClick={() => {
          onSubmit(saveInternalUserRequest)
        }}
        disabled={!formIsValid}
        type="primary"
      >
        {translate('general.save')}
      </Button>
    )
  }

  const formFooter = (
    <div>
      <Button className={'mr-8'} onClick={onCancel}>
        {translate('general.cancel')}
      </Button>
      <SaveButtonWithTooltip />
    </div>
  )

  const formRef = useRef(null)

  return (
    <Modal
      onCancel={onCancel}
      visible={visible}
      title={translate('csi-dashboard.internal-users.add-internal-user')}
      footer={formFooter}
    >
      <Formik
        enableReinitialize={true}
        validationSchema={formValidator(translate)}
        initialValues={initialValues}
        onSubmit={(values) => {}}
        validate={(values: InternalUserFoSave) => {
          setFormIsValid(formValidator(translate).isValidSync(values))

          setSaveInternalUserRequest({
            apps: values.apps.map((a) => parseInt(a.toString())),
            id: values.id,
          } as SaveInternalUserRequest)

          return {}
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit} autoComplete="off" ref={formRef}>
            <Row gutter={16}>
              <Col span={24}>
                <div className="mb-8">
                  <label>{translate('general.roles')}</label>
                </div>

                <FormikCheckboxGroupField defaultValue={initialValues.apps} name="apps">
                  {initialValues.availableApps.map((app) => (
                    <div className={'mb-8'}>
                      <Checkbox value={app.id} key={app.id}>
                        {app.name}
                      </Checkbox>
                      <br />
                    </div>
                  ))}
                </FormikCheckboxGroupField>
              </Col>
            </Row>
          </form>
        )}
      </Formik>
    </Modal>
  )
}

interface InternalUsersFormProps {
  visible: boolean
  onCancel: (e: React.MouseEvent<HTMLElement>) => void
  initialValues: InternalUserFoSave
  onSubmit: (values: SaveInternalUserRequest) => void | Promise<any>
  submitting: boolean
}

const formValidator = (translate: any) => Yup.object({})
export default InternalUsersForm
